import { i18n } from '@/i18n';

export default function useWeightHelpers() {
  const normalizeWeightValueString = (value) => parseFloat(value.toFixed(3)).toString();

  const getWeight = (weight) => {
    const value = parseFloat(weight?.value);

    if (Number.isNaN(value) || value === 0) {
      return i18n.t('common.unknown');
    }

    if (weight.is_metric) {
      return `${value} kg`;
    }

    return `${normalizeWeightValueString(value)} lb`;
  };

  return {
    getWeight,
    normalizeWeightValueString,
  };
}
